import React from 'react';
import moment from 'moment-timezone';
import utils from 'utils';
import { Client } from 'api';
import Tracker from 'tracker';
import NewMessage from 'components/events/newMessage';
import VendorStrip from 'components/events/vendorStrip';

export default class Messages extends React.Component {
    constructor(props) {
        super(props);

        this.api = new Client();
        this.tracker = new Tracker();

        this.state = {
            lead_id: this.props.lead.id,
            messages: this.props.lead.messages,
            saving: false,
        };
    }

    static scrollToBottom() {
        const container = document.querySelector('.messages');
        container.scrollTop = container.scrollHeight;
    }

    componentDidMount() {
        Messages.scrollToBottom();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lead_id !== nextProps.lead.id) {
            this.setState({
                lead_id: nextProps.lead.id,
                messages: nextProps.lead.messages,
                saving: false,
            }, () => {
                Messages.scrollToBottom();
            });
        }
    }

    handleSubmit = ({ newMessage, attachments }, finished, error) => {
        this.setState({ saving: true });

        this.api.request(`/api/leads/${this.props.lead.id}/messages`, {
            method: 'POST',
            data: {
                body: newMessage,
                attachments: attachments,
            },
            success: response => {
                if (response.error) {
                    this.setState({ saving: false }, () => {
                        this.tracker.logMessage('Error saving new message', {
                            has_attachments: attachments.length > 0,
                            new_message: newMessage,
                            error: response.error,
                        });
                        error(response.error);
                    });
                    return;
                }

                const messages = this.state.messages;
                messages.push(response);

                this.setState({
                    saving: false,
                    messages: messages,
                }, () => {
                    Messages.scrollToBottom();
                    finished();
                });
            },
            error: () => {
                this.setState({ saving: false }, () => {
                    error('An unexpected error occurred, please try again or contact us if the problem persists.');
                    this.tracker.logMessage('Error saving new message', {
                        has_attachments: attachments.length > 0,
                        new_message: newMessage,
                    });
                });
            },
        });
    };

    render() {
        const vendor = this.props.lead.vendor;

        let currentStamp;
        let messageStamp;

        return (
            <div>
                <h4>Messages</h4>

                <div className="messages-wrapper">
                    {this.props.lead.options.locked && <div className="vendor-strip alert-warning">
                        The user has decided to pass on your proposal for the following reason: {this.props.lead.options.reason}
                    </div>}

                    <VendorStrip
                        vendor={vendor}
                        lead={this.props.lead}
                        includeActions={false}
                    />
                    <div className="messages" ref="messageContainer">
                        {this.props.lead.messages.map((message) => {
                            const output = [];
                            const readOn = message.read_on ? moment(message.read_on).fromNow() : null;
                            let body = message.body;

                            messageStamp = moment(message.sent_on).format('dddd, MMMM Do, h:mm a');
                            if (messageStamp !== currentStamp) {
                                currentStamp = messageStamp;
                                output.push((
                                    <div className="message-divider">{messageStamp}</div>
                                ));
                            }

                            body = body.replace(vendor.name, "<a href=/vendor/" + vendor.slug + " target=\"_blank\" rel=\"noopener noreferrer\">" + vendor.name + "</a>");

                            output.push((
                                <div className="message" key={`messageBody${message.id}`}>
                                    <div className="sender">
                                        {message.profile_photo.small && <img src={message.profile_photo.small} className="profile-photo" />}
                                        {message.profile_photo.initials && <div className="default-profile-photo">{message.profile_photo.initials}</div>}
                                    </div>
                                    <div className="message-body">
                                        <div className="sender-name">
                                            {message.sent_by}
                                            {message.sender_type === 'vendor' && !readOn && <span className="unread-indicator">Unread</span>}
                                            {message.sender_type === 'vendor' && readOn && <span className="read-timestamp">Read {readOn}</span>}
                                        </div>
                                        <div dangerouslySetInnerHTML={{ __html: utils.simple_format(body) }}></div>
                                        {message.attachments.length > 0 && <div className="message-attachments">
                                            <strong>Attachments:</strong>
                                            {message.attachments.map((attachment) => {
                                                return <a
                                                    key={`attachment${attachment.id}`}
                                                    href={attachment.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="attachment-link"
                                                >
                                                    {attachment.filename}
                                                </a>;
                                            })}
                                        </div>}
                                    </div>
                                </div>
                            ));

                            return output;
                        })}
                    </div>

                    <div className="new-message">
                        <NewMessage saving={this.state.saving} onSubmit={this.handleSubmit} />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/leads/messages.jsx